import { render } from "./Vnud-Ver_Inscritos.vue?vue&type=template&id=4abb539a"
import script from "./Vnud-Ver_Inscritos.vue?vue&type=script&lang=js"
export * from "./Vnud-Ver_Inscritos.vue?vue&type=script&lang=js"

import "./Vnud-Ver_Inscritos.vue?vue&type=style&index=0&id=4abb539a&lang=css"

import exportComponent from "C:\\Users\\ricar\\OneDrive\\Ambiente de Trabalho\\Plataforma_eventos\\registar-evento\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__